export default __webpack_public_path__ + "static/media/img-02.3577ba04.jpg";